export default __webpack_public_path__ + "static/media/06.96efe680.jpg";